<template>
    <option :value="value" disabled>{{ $t('general.select_default') }}</option>
</template>

<script setup lang="ts">
const { value = null } = defineProps<{
    value?: any
}>()
</script>

<style scoped>

</style>
